<script>
export default {
    name: "Nav",
    data() {
        return {
            navPopup: false
        };
    },
    computed: {
        userNbInfo() {
            return this.$store.state.userNbInfo;
        },
        migoLiffId() {
            return this.$store.state.migoLiffId;
        },
    },
    methods:{
        handleNavAlert() {
            // 發送事件給父層 view
            // this.$emit('trigger-action')
            this.navPopup = true
        },
        closePopup(){
            // document.querySelector('.popup').style.display = 'none'
            this.navPopup = false
        },
    }
};
</script>

<template src="./template.pug" lang="pug"></template>
<style src="./style.sass" lang="sass" scoped></style>
